// extracted by mini-css-extract-plugin
export default {"input":"Annulment_input__lnU5J","button":"Annulment_button__uWnET"};